import { GET_RELATED_ALERTS, GET_RELATED_ALERTS_URL } from '../constants/constants';
import { getService, getAxiosHeaders } from '../../library/RestAPI';

export async function getRelatedAlerts(id,pageSize,currentPage) {
    const options = {
        method: "GET",
        url: `${GET_RELATED_ALERTS_URL}/${id}/related?size=${pageSize}&page=${currentPage}`,
        headers: getAxiosHeaders(true),
        data: {}
    };

    const response = await getService(options);
    if(response) {
        return response.data
    }
    
    // axios.get(`${GET_ALERT_POLICIES_URL}?size=20`).then(res => {
        
    //     if (res && res.data && res.status === 200) {
    //         console.log(res.data)
    //         return res.data.content
    //     }
    // })
};

